export * from './lib/data-doughnut-chart.module';
